import app from 'flarum/forum/app';
import Search from 'flarum/forum/components/Search';

app.initializers.add('rhospital-search-minimum-length', () => {
  Search.MIN_SEARCH_LEN = 2;
});
